<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>复用记录列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">复用系统</label>
              <jm-dict-select
                :disabled="$hasPermission([33, 121, 148, 85, 91]) && !$hasPermission(1)"
                class="jm-input280"
                clearable
                type="jiemo"
                dict-type="site_name"
                name="site_name"
                value-type="String"
                v-model="searchData.target_tag"/>
            </div>
            <div class="box-content">
              <label class="form-tit">是否签约</label>
              <el-select
                class="jm-input280"
                v-model="searchData.customer_status"
                clearable
                placeholder="请选择">
                <el-option
                  label="是"
                  :value="1"/>
                <el-option
                  label="否"
                  :value="2"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">签约日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.sign_date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">是否有效</label>
              <el-select
                class="jm-input280"
                v-model="searchData.effective"
                clearable
                placeholder="请选择">
                <el-option
                  label="有效"
                  :value="1"/>
                <el-option
                  label="无效"
                  :value="2"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">发起人</label>
              <el-select
                filterable
                v-model="searchData.create_person"
                class="jm-input280"
                clearable
                placeholder="请选择">
                <el-option-group
                  v-for="(group, k) in ds.create_person"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item['username']"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">创建日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.reg_time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">客户编码</label>
              <el-input
                v-model="searchData.origin_id"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">联系方式</label>
              <el-input
                v-model="searchData.contact_way"
                class="jm-input280"/>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input-common3"
              type="success"
              @click="exportDetails"
              :loading="btnLoading">导出明细</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            url="/index/reuse/index"
            :search-data="searchData"
          >
            <el-table-column
              slot="origin_name"
              label="原系统信息">
              <template slot-scope="scope">
                <a href="javascript:void(0)" @click.stop="jumpEdit(scope.row, 1)"><el-tag>{{ scope.row.origin_tag_str }}</el-tag></a>
                <br>
                {{ scope.row.origin_name }}
              </template>
            </el-table-column>
            <el-table-column
              slot="target_name"
              label="复用系统信息">
              <template slot-scope="scope">
                <a href="javascript:void(0)" v-show="scope.row.sync_to" @click.stop="jumpEdit(scope.row, 2)"><el-tag>{{ scope.row.target_tag_str }}</el-tag></a>
                <br>
                {{ scope.row.target_name }}
              </template>
            </el-table-column>
            <el-table-column
              slot="url"
              label="截图">
              <template slot-scope="scope">
                <img style="max-height: 40px; cursor: pointer" @click="viewBigImg(scope.row.url)" :src="scope.row.url" alt="">
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>
    <view-large-image :visible.sync="viewImageLock" :img-url="reuseImage"></view-large-image>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import viewLargeImage from '@/components/pop/viewLargeImage';
import { formatSelectGroupData } from '@/utils/utils.js';

function getDefaultSearch() {
  return {
    target_tag: process.env.VUE_APP_SITE_NAME === 'fib' ? 'training' : 'fib',
    customer_status: '',
    sign_date: '',
    effective: '',
    create_person: '',
    reg_time: '',
    origin_id: '',
    contact_way: '',
  };
}
export default {
  data() {
    return {
      searchData: getDefaultSearch(),
      btnLoading: false,
      ds: [],
      viewImageLock: false,
      reuseImage: ''
    };
  },
  computed: {
  },
  methods: {
    // 跳转详情
    jumpEdit(row, t) {
      let user = {
        id: row.sync_from,
        site: row.origin_tag
      };
      if (t === 2) {
        user = {
          id: row.sync_to,
          site: row.target_tag
        };
      }
      let routeData = '';
      switch (user.site) {
        case 'fib':
          routeData = this.$router.resolve({ name: 'fibReuseDetail', params: { id: user.id } });
          window.open(routeData.href, '_blank');
          break;
        case 'training':
          routeData = this.$router.resolve({ name: 'trainingReuseDetail', params: { id: user.id } });
          window.open(routeData.href, '_blank');
          break;
        default:
          break;
      }
    },
    // 查看大图
    viewBigImg(url) {
      if (url) {
        this.reuseImage = url;
        this.viewImageLock = true;
      } else {
        this.$message.error('图片路径错误');
      }
    },
    // 获取页面数据
    getPageData() {
      // 获取字典
      this.$http
        ._post({
          url: '/index/reuse/searchDs'
        })
        .then((res) => {
          this.ds = res.data;
          this.ds.create_person = formatSelectGroupData(res.data.create_person);
          delete this.ds.create_person.ZZ;
        });
      if (!this.$hasPermission([62, 81, 154])) {
        this.searchData.target_tag = this.$hasPermission([33, 121, 148]) ? 'training' : 'fib';
      }
    },
    // 重置搜索
    resetFields() {
      this.searchData = getDefaultSearch();
      if (!this.$hasPermission([62, 81, 154])) {
        this.searchData.target_tag = this.$hasPermission([33, 121, 148]) ? 'training' : 'fib';
      }
      this.$store.commit('updateRefresh', true);
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/index/reuse/report',
          data: { searchData: this.searchData }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '复用报表.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    viewLargeImage
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped>
  .tableList .el-button{
    padding: 0 13px;
  }
  .el-tooltip{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
</style>
